'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.queryUploadReport = queryUploadReport;
exports.downloadTemplate = downloadTemplate;
exports.upload = upload;
exports.getFileUploadPolicy = getFileUploadPolicy;
exports.pageQuery = pageQuery;
exports.clearTable = clearTable;
exports.batchDelete = batchDelete;
exports.saveRows = saveRows;
exports.asyncDownloadTemplate = asyncDownloadTemplate;
exports.queryAsyncTemplateResponse = queryAsyncTemplateResponse;
exports.uploadStatusQuery = uploadStatusQuery;
exports.templateStatusQuery = templateStatusQuery;
exports.pageQueryShareData = pageQueryShareData;
exports.addAllFormDataShare = addAllFormDataShare;
exports.addAllFormDataShareReport = addAllFormDataShareReport;
exports.addAllFormDataShareStatusQuery = addAllFormDataShareStatusQuery;
exports.downloadTemplateForDesigner = downloadTemplateForDesigner;
exports.removeBigTableCache = removeBigTableCache;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _requestOlympics2.default;
function queryUploadReport(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/table/queryUploadReport', {
    params: {
      sequenceNo: params.sequenceNo,
      matterId: params.matterId,
      tablePropertyId: params.tablePropertyId,
      timestamp: new Date().getTime()
    }
  }).then(resErrorJudge);
}

function downloadTemplate(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/table/downloadTemplate', {
    params: _extends({}, params, {
      timestamp: new Date().getTime()
    })
  }).then(resErrorJudge);
}

function upload(data) {
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/upload', data).then(resErrorJudge);
}

function getFileUploadPolicy() {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/file/getFileUploadPolicy').then(resErrorJudge);
}

function pageQuery(params) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var searchParam = arguments[3];

  var __ctx__ = window.__ctx__;
  var url = ((__ctx__ && __ctx__.getGlobalProps() || {}).formOptions || {}).tableQueryUrl || '/form/table/pageQuery';
  return _requestOlympics2.default.post((0, _request.transformUrl)(url), _extends({}, params, {
    page: page,
    count: count,
    searchParam: searchParam
  })).then(resErrorJudge);
}

function clearTable(data) {
  return (0, _requestOlympics2.default)({
    method: 'post',
    url: (0, _request.urlPrefix)() + '/form/table/clearTable',
    data: data
  }).then(resErrorJudge);
}

function batchDelete(data) {
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/batchDelete', data).then(resErrorJudge);
}

function saveRows(params) {
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var edit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var rowList = rows.map(function () {
    var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
      rowData: JSON.stringify(row.rowData),
      rowId: row.rowId,
      bigTableRowKey: params.bigTableRowKey
    };
  });
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/saveRows', _extends({}, params, {
    edit: edit,
    rowList: rowList
  })).then(resErrorJudge);
}

function asyncDownloadTemplate(params) {
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/asyncDownloadTemplate', params).then(resErrorJudge);
}

function queryAsyncTemplateResponse(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/table/queryAsyncTemplateResponse', { params: _extends({}, params, { timestamp: new Date().getTime() }) }).then(resErrorJudge);
}

/**
 * 上传状态查询
 * @param {Object} params 请求参数
 * @param {Object} envents 事件回调
 * @param {Number} times 请求次数
 * @param {Number} interval  请求间隔
 */
function uploadStatusQuery(params, events) {
  var MAX_TIMES = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5e3;
  var onProgress = events.onProgress,
      onSuccess = events.onSuccess,
      onError = events.onError;

  var currentProgess = 0;

  var progressCall = function progressCall() {
    return queryUploadReport(params).then(function (data) {
      // 该状态下  成功
      if (data.status === 'PROCESS_FINISHED') {
        // 处理完成 先把进度条设置为100%
        onProgress({ total: 1, guessTotalRows: 1 });

        // 1s以后再触发成功回调
        setTimeout(function () {
          return onSuccess(data);
        }, 1e3);
        return;
      }

      if (currentProgess >= MAX_TIMES) {
        onError(new Error('等待超时'), null);
        return;
      }

      // 该状态下 仅仅通知   不中止流程
      if (data.status === 'PROCESSING') {
        onProgress(data);
      }

      currentProgess++;
      return new Promise(function (resolve) {
        setTimeout(resolve, interval);
      }).then(progressCall);
    }).catch(onError);
  };
  progressCall();
}

/**
 * 模板状态查询
 * @param {Object} params 请求参数
 * @param {Object} envents 事件回调
 * @param {Number} times 请求次数
 * @param {Number} interval  请求间隔
 */
function templateStatusQuery(params, events) {
  var MAX_TIMES = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2e3;
  var onProgress = events.onProgress,
      onSuccess = events.onSuccess,
      onError = events.onError,
      onAbort = events.onAbort;

  var currentProgess = 0;

  var _abort = false;
  var sequenceNo = params.sequenceNo,
      tablePropertyId = params.tablePropertyId,
      matterId = params.matterId;

  var progressCall = function progressCall() {
    return queryAsyncTemplateResponse({ sequenceNo: sequenceNo, tablePropertyId: tablePropertyId, matterId: matterId }).then(function (data) {
      if (_abort) {
        onAbort && onAbort();
        return;
      }

      // 该状态下  成功航司
      if (data.status === 'PROCESS_FINISHED') {
        onSuccess(data);
        return;
      }

      if (currentProgess >= MAX_TIMES) {
        onError(new Error('等待超时'), null);
        return;
      }

      // 该状态下 仅仅通知   不中止流程
      if (data.status === 'PROCESSING') {
        onProgress(data);
      }

      currentProgess++;
      return new Promise(function (resolve) {
        setTimeout(resolve, interval);
      }).then(progressCall);
    }).catch(onError);
  };

  asyncDownloadTemplate(params).then(progressCall).catch(onError);
  return {
    abort: function abort() {
      return _abort = true;
    }
  };
}

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}

function pageQueryShareData(params) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var formData = arguments[3];
  var searchParam = arguments[4];

  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/pageQueryShareData', _extends({}, params, {
    page: page,
    count: count,
    formData: formData,
    searchParam: searchParam
  })).then(resErrorJudge);
}

function addAllFormDataShare(params, formData, searchParam) {
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/table/addAllFormDataShare', _extends({}, params, { formData: formData, searchParam: searchParam })).then(resErrorJudge);
}

function addAllFormDataShareReport(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/table/queryAddAllFormDataShareResponse', {
    params: _extends({}, params, {
      timestamp: new Date().getTime()
    })
  }).then(resErrorJudge);
}

function addAllFormDataShareStatusQuery(params, events) {
  var MAX_TIMES = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5e3;
  var onSuccess = events.onSuccess,
      onError = events.onError;

  var currentProgess = 0;

  var progressCall = function progressCall() {
    return addAllFormDataShareReport(params).then(function (data) {
      // 该状态下  成功回调
      if (data.status === 'PROCESS_FINISHED') {
        onSuccess(data);
        return;
      }

      if (currentProgess >= MAX_TIMES) {
        onError(new Error('等待超时'), null);
        return;
      }

      currentProgess++;
      return new Promise(function (resolve) {
        setTimeout(resolve, interval);
      }).then(progressCall);
    }).catch(onError);
  };
  progressCall();
}

function downloadTemplateForDesigner(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/rest/api/form/downloadTemplate', { params: _extends({}, params, { timestamp: new Date().getTime() }) }).then(resErrorJudge);
}

/**
 * 用于清除大表格脱敏缓存，调用即可，不需要根据返回值进行判断，
 * @param {*} p
 * @returns
 */
function removeBigTableCache() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/form/table/removeBigTableCache', { params: _extends({}, p, { timestamp: +new Date() }) }).catch(function () {});
}